import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IShield from '@meronex/icons/fi/FiShield';

import AddRoleDialog from './AddRoleDialog';
import EditRoleDialog from './EditRoleDialog';
import RolesList from './RolesList';
import TopHeader from '../../../views/components/TopHeader';

import { rolesMng } from '../api/rolesMng';

function RolesDialog(props) {
  const { open, onClose } = props;

  const [openAddRole, setOpenAddRole] = React.useState(false);
  const [openEditRole, setOpenEditRole] = React.useState(false);
  const [selectedRole, setSelectedRole] = React.useState();
  const [roles, setRoles] = React.useState();

  const getRoles = async () => {
    const roles = await rolesMng.getRoles();
    setRoles(roles);
  };

  React.useEffect(() => {
    getRoles();
  }, []);

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <TopHeader
          title={'Roles'}
          onClose={onClose}
          icon={<IShield size={20} />}
          actionLabel={'Add Role'}
          onAction={() => {
            setSelectedRole(false);
            setOpenAddRole(true);
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0px' }}>
        <RolesList
          roles={roles}
          onEdit={(role) => {
            setSelectedRole(role);
            setOpenEditRole(true);
          }}
          onDelete={getRoles}
        />
      </DialogContent>
      {openAddRole && (
        <AddRoleDialog
          open={openAddRole}
          onAdd={getRoles}
          onClose={() => {
            setOpenAddRole(false);
            setSelectedRole(null);
          }}
        />
      )}
      {openEditRole && (
        <EditRoleDialog
          open={openEditRole}
          role={selectedRole}
          onEdit={getRoles}
          onClose={() => {
            setOpenEditRole(false);
            setSelectedRole(false);
          }}
        />
      )}
    </Dialog>
  );
}

RolesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default RolesDialog;
